/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum OrganizationByInnStatusEnum {
  Active = 'ACTIVE',
  Liquidating = 'LIQUIDATING',
  Liquidated = 'LIQUIDATED',
}

export function instanceOfOrganizationByInnStatusEnum(value: any): boolean {
  for (const key in OrganizationByInnStatusEnum) {
    if (
      Object.prototype.hasOwnProperty.call(OrganizationByInnStatusEnum, key)
    ) {
      if (
        OrganizationByInnStatusEnum[
          key as keyof typeof OrganizationByInnStatusEnum
        ] === value
      ) {
        return true
      }
    }
  }
  return false
}

export function OrganizationByInnStatusEnumFromJSON(
  json: any
): OrganizationByInnStatusEnum {
  return OrganizationByInnStatusEnumFromJSONTyped(json, false)
}

export function OrganizationByInnStatusEnumFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): OrganizationByInnStatusEnum {
  return json as OrganizationByInnStatusEnum
}

export function OrganizationByInnStatusEnumToJSON(
  value?: OrganizationByInnStatusEnum | null
): any {
  return value as any
}
